import React, { FC } from 'react';

import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { Link, Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { useBreadcrumbStyles } from './Breadcrumbs.styles';

export interface BreadcrumbsProps {
  items: Array<{
    label: string;
    path: string;
  }>;
  source: 'items' | 'location';
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({
  items = [],
  source = 'location',
}: BreadcrumbsProps) => {
  const classes = useBreadcrumbStyles();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const breadcrumbs = [];
  const pathnames = pathname.split('/').filter(name => name);
  let currentPath = '';

  switch (source) {
    case 'items':
      items.forEach(item => {
        breadcrumbs.push({
          label: item.label,
          path: item.path,
        });
      });
      break;
    case 'location':
      pathnames.forEach(pathname => {
        currentPath += `/${pathname}`;
        breadcrumbs.push({
          label: pathname,
          path: currentPath,
        });
      });
      break;
    default:
      break;
  }

  return (
    <MuiBreadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
      {breadcrumbs.length > 0 && (
        <Link
          data-testid="breadcrumbs-home"
          className={classes.breadcrumb}
          underline="none"
          color="inherit"
          onClick={() => navigate('/')}
        >
          Home
        </Link>
      )}
      {breadcrumbs.map((breadcrumb, index) => {
        const isLastBreadcrumb = index === breadcrumbs.length - 1;

        return isLastBreadcrumb || !breadcrumb.path ? (
          <Typography key={breadcrumb.path} color="textPrimary">
            {breadcrumb.label}
          </Typography>
        ) : (
          <Link
            data-testid={`breadcrumbs-${index + 1}`}
            className={classes.breadcrumb}
            key={breadcrumb.path}
            underline="none"
            color="inherit"
            onClick={() => navigate(breadcrumb.path)}
          >
            {breadcrumb.label}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};
